<template>
    <!-- 하다희 - 오늘날짜 CSS 필요 -->
    <li><button 
        :class="{'notthismonth':isThisMonth==false, 'selected':isSelected}"
        @click="action_SelectDate"
    >
        {{ dayString }}
    </button></li>
</template>


<script>
import { setSelectedDate } from '../../../sheet-axis'
import moment from '@/util/MPMoment'
export default {
    props: {
        today: Object,
        selectedDate: Object,
        date: Object,
        currentMonth: Object,
    },
    computed: {
        isThisMonth: function() {
            if (this.date.isBefore(moment(this.currentMonth).startOf('months'))) { return false }
            if (this.date.isAfter(moment(this.currentMonth).endOf('months'))) { return false }
            return true
        },
        isToday: function() {
            return this.selectedDate.isEqual(this.today)
        },
        dayString: function() {
            return this.date.format('D')
        },
        isSelected: function() {
            if (this.selectedDate.format('YYYY-MM-DD') == this.date.format('YYYY-MM-DD')) { return true }
            return false
        }
    },
    methods: {
        action_SelectDate() {
            setSelectedDate(moment(this.date))
        }
    }
}
</script>